import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

const drinksMenuDe = JSON.stringify([
  {
    title: 'Cocktails',
    items: [
      { name: 'Negroni', price: '12 €', description: 'Gin, Campari, Vermouth' },
      { name: 'Espresso Martini', price: '13 €', description: 'Vodka, Kaffee, Kahlúa' },
    ],
  },
  {
    title: 'Bier',
    items: [
      { name: 'Helles vom Fass', price: '4,50 €', description: '0,3 l' },
      { name: 'IPA Flasche', price: '5,50 €', description: '0,33 l' },
    ],
  },
]);

const drinksMenuEn = JSON.stringify([
  {
    title: 'Cocktails',
    items: [
      { name: 'Negroni', price: '12 €', description: 'Gin, Campari, vermouth' },
      { name: 'Espresso Martini', price: '13 €', description: 'Vodka, coffee, Kahlúa' },
    ],
  },
  {
    title: 'Beer',
    items: [
      { name: 'Helles on tap', price: '4,50 €', description: '0.3 l' },
      { name: 'IPA bottle', price: '5,50 €', description: '0.33 l' },
    ],
  },
]);

export const drinksListStaticDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.drinksList,
  componentType: LAYOUT_COMPONENT_TYPE.drinksListStatic,
  registryBlockKey: REGISTRY_BLOCK.presentation.drinksListStatic,
  displayOrder: 2,
  content: {
    sectionTitle: loc3('Getränke', 'Drinks', 'Đồ uống'),
    sectionSubtitle: loc3(
      'Cocktails und Bier — frisch gemixt.',
      'Cocktails and beer — freshly mixed.',
      'Cocktail và bia — pha mới.',
    ),
    menuData: loc3(drinksMenuDe, drinksMenuEn, drinksMenuEn),
  },
  media: {},
};

const wineMenuDe = JSON.stringify([
  {
    title: 'Weiß',
    items: [
      { name: 'Riesling, Mosel', price: '12 €', description: '0,1 l · Schiefer, trocken' },
      { name: 'Weißburgunder, Pfalz', price: '11 €', description: '0,1 l · nussig, ruhig' },
    ],
  },
  {
    title: 'Rot',
    items: [
      { name: 'Spätburgunder, Baden', price: '13 €', description: '0,1 l · kühl, fein' },
      { name: 'Blaufränkisch, Carnuntum', price: '12 €', description: '0,1 l · Kräuter, Kirsche' },
    ],
  },
]);

const wineMenuEn = JSON.stringify([
  {
    title: 'White',
    items: [
      { name: 'Riesling, Mosel', price: '12 €', description: '0.1 l · slate, dry' },
      { name: 'Pinot blanc, Pfalz', price: '11 €', description: '0.1 l · nutty, calm' },
    ],
  },
  {
    title: 'Red',
    items: [
      { name: 'Pinot noir, Baden', price: '13 €', description: '0.1 l · cool, fine' },
      { name: 'Blaufränkisch, Carnuntum', price: '12 €', description: '0.1 l · herbs, cherry' },
    ],
  },
]);

export const drinksListCellarDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.drinksListCellar,
  componentType: LAYOUT_COMPONENT_TYPE.drinksListStatic,
  registryBlockKey: REGISTRY_BLOCK.presentation.drinksListCellar,
  displayOrder: 2,
  content: {
    sectionTitle: loc3('Weinkarte', 'Wine list', 'Thực đơn rượu'),
    sectionSubtitle: loc3(
      'Glas und Flasche — Sommelier berät zur Weinbegleitung.',
      'By the glass and bottle — the sommelier advises on pairing.',
      'Ly và chai — sommelier tư vấn kèm món.',
    ),
    menuData: loc3(wineMenuDe, wineMenuEn, wineMenuEn),
  },
  media: {},
};

export const drinksListSheetDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.drinksListSheet,
  componentType: LAYOUT_COMPONENT_TYPE.drinksListStatic,
  registryBlockKey: REGISTRY_BLOCK.presentation.drinksListSheet,
  displayOrder: 2,
  content: {
    sectionTitle: loc3('Weinkarte', 'Wine list', 'Thực đơn rượu'),
    sectionSubtitle: loc3(
      'Glas und Flasche — Sommelier berät zur Weinbegleitung.',
      'By the glass and bottle — the sommelier advises on pairing.',
      'Ly và chai — sommelier tư vấn kèm món.',
    ),
    menuData: loc3(wineMenuDe, wineMenuEn, wineMenuEn),
  },
  media: {},
};
